export const capitalise = (s: string): string => {
  if (!s || s.length === 0) {
    return s;
  }
  return s[0].toUpperCase() + s.slice(1);
};

export const getFileFormatFromString = (url: string): string => {
  if (!url || typeof url !== 'string') {
    return '';
  }
  const match = url.match(/.+\.(\w+)$/);
  return match ? match[1] : '';
};

export const isBlankString = (string: string): boolean => {
  if (!string) {
    return true;
  }
  return !string.length || /^\s*$/.test(string);
};

export const removeNewLines = (string: string): string => {
  if (!string) {
    return '';
  }
  return string.replace(/[\r\n]+/g, '');
};
